'use strict';

import axios from 'axios';
import { handleError } from '@/_helpers/utils.js';

export default {
  namespaced: true,
  state() {
    return {
      data: null,
      loaded: false,
      error: null
    }
  },
  actions: {
    load(context) {
      context.commit('setLoaded', false);
      context.commit('setError', null);

      return axios.get(`/1.0/spec-private/bcg/results/${context.rootGetters['response/one'].id}`)
        .then(response => response.data)
        .then(data => {
          context.commit('setData', data);
          context.commit('setLoaded', true);
        })
        .catch(err => {
          err = handleError(err);
          context.commit('setError', err);
          throw err;
        })
    }
  },
  mutations: {
    setData(state, data) {
      state.data = data;
    },
    setLoaded(state, loaded) {
      state.loaded = loaded;
    },
    setError(state, error) {
      state.error = error;
    }
  },
  getters: {
    data: (state) => state.data,
    error: (state) => state.error,
    loaded: (state) => state.loaded,
    test: (state, getters) => getters.data ? getters.data.test : null,
    status: (state, getters) => getters.data ? getters.data.status : null,
    result: (state, getters) => getters.data ? getters.data.result : null,
    block_results: (state, getters) => getters.data ? getters.data.block_results : null,
    question_results: (state, getters) => getters.data ? getters.data.question_results : null,
    category_results: (state, getters) => getters.data ? getters.data.result.category_results : null,
  }
}
